export default __webpack_public_path__ + "static/media/img-ln-8-seller.49a7b737.png";